import {getInitialProps as bodyTypesInitialProps} from './BodyTypes/getInitialProps.js'
import {getInitialProps as fuelTypesInitialProps} from './FuelTypes/getInitialProps.js'
import {getInitialProps as makesInitialProps} from './Makes/getInitialProps.js'
import {getInitialProps as priceRangeInitialProps} from './PriceRange/getInitialProps.js'
import {getInitialProps as resultsInitialProps} from './Results/getInitialProps.js'
import {getInitialProps as seatsInitialProps} from './Seats/getInitialProps.js'
export const getInitialProps = async initialProperties => {
  try {
    const {
      routeInfo,
      context: {domain}
    } = initialProperties
    const {
      location: {pathname: path}
    } = routeInfo

    const config = domain.get('config')
    const {
      VEHICLE_SUGGESTER_PAGE_NAME,
      VEHICLE_SUGGESTER_BODY_TYPE_PAGE_NAME,
      VEHICLE_SUGGESTER_FUEL_TYPE_PAGE_NAME,
      VEHICLE_SUGGESTER_SEATS_PAGE_NAME,
      VEHICLE_SUGGESTER_MAKES_PAGE_NAME,
      VEHICLE_SUGGESTER_RESULTS_PAGE_NAME
    } = config.get('page')

    const {pageName} = await domain.get('get_page_name_page_use_case').execute({path})

    if (!pageName) {
      // Motos has no VEHICLE_SUGGESTER_* page config (coches-only feature, see
      // packages/domain/src/config/motos/page.js), so this is the normal path on motos — not a
      // bug to log. A thrown Response reaches entry.server.tsx untouched and renders the branded
      // 404 page, matching what production answers for /ayudame-a-elegir on motos today.
      throw new Response(null, {status: 404})
    }

    switch (pageName) {
      case VEHICLE_SUGGESTER_PAGE_NAME:
        // return await import(
        //   /* webpackChunkName: "VehicleSuggester-PriceRange-getInitialProps" */ './PriceRange/getInitialProps.js'
        // )
        return priceRangeInitialProps(initialProperties)
      case VEHICLE_SUGGESTER_BODY_TYPE_PAGE_NAME:
        return bodyTypesInitialProps(initialProperties)
      case VEHICLE_SUGGESTER_FUEL_TYPE_PAGE_NAME:
        return fuelTypesInitialProps(initialProperties)
      case VEHICLE_SUGGESTER_SEATS_PAGE_NAME:
        return seatsInitialProps(initialProperties)
      case VEHICLE_SUGGESTER_MAKES_PAGE_NAME:
        return makesInitialProps(initialProperties)
      case VEHICLE_SUGGESTER_RESULTS_PAGE_NAME:
        return resultsInitialProps(initialProperties)
      default:
        throw new Error(`No initial props function defined for page name: ${pageName}`)
    }
  } catch (error) {
    // A thrown Response (e.g. the 404 above) is expected control flow, not a failure — don't log it.
    if (error instanceof Response) throw error
    console.error('[VehicleSuggester - getInitialProps] error: ', error)
    throw error
  }
}
